import Styled, { css } from 'styled-components';

import { cssDeclaration } from '../../_ThemeTwo_/Utils/Styles/cssDeclaration';

import { ICheckboxContain } from './common';

export const CheckboxLabel = Styled.label<ICheckboxContain>`
  color: ${({ theme: { text }}) => text.colorText};
  cursor: pointer;
  line-height: 2.2rem;
  align-items: center;
  padding: 0;
  margin: -3px 0 0 1.625em;
  display: flex;
  font-size: ${({ theme: { checkbox } }) => checkbox.fontSize};

  &::before,
  &::after {
    display: inline-block;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0.4375em;
    left: 0.4375em;
    z-index: 2;
    width: 0.875em;
    height: 0.875em;
    border:
      ${({ theme: { input } }) => input.borderWidth}
      solid
      ${({ theme: { brand, checkbox }, alert }) => alert ? brand.colorAlert : checkbox.colorBorder};
    background: ${({ theme }) => theme.colorWhite};
    border-radius: ${({ theme: { input }}) => input.borderRadius};

    ${({ theme }) => theme.checkbox.error && css`
      /* border */ ${theme.checkbox.error.border && cssDeclaration(theme.themeTwo, 'border', theme.checkbox.error.border)};
    `}
  }
`;
